import Indicador from "..";
import EditFields from "./components/EditFields";
import { ParamFields } from "./components/ParamFields";
import Report from "./reports";
import ReportSummary from "./reports/summary";

export default class UQL extends Indicador {
    static get fullName() {
        return "Uniformidade Quebra Lombo";
    }

    static get abbrev() {
        return "UQL";
    }


    static get legacyApontamentoMap() {
        const convertPontos = (values, atual) => {
            let coletas = []
            if (values) {
                values.forEach(ponto => {
                    coletas = coletas.concat(ponto.coletas.map(c => { return { coleta: c.coleta } }))
                });
            }
            return coletas
        }

        return {
            // Data/Hora de PS está realmente como 'dataHoraNGV' no banco.
            dataHora: {
                newField: "date",
                convert: this.parseLegacyDate,
            },

            tipo: "tipo",
            talhao: "talhao",
            trator: "trator",
            implemento: "implemento",
            equipamento: "equipamento",
            frente: "frente",

            pontos: { newField: "coletas", convert: convertPontos, },

            conformidadeAmostra: "conformidade",

            observacaoAmostra: "observacao",

            itensColeta: "images",
        };
    }

    static get legacyParamMap() {
        return {
            qLIntervaloMinimoManual: "manual.intervaloMin",
            qLIntervaloMaximoManual: "manual.intervaloMax",
            qLMetaManual: "manual.meta",

            qLIntervaloMinimoMecanizado: "mecanizado.intervaloMin",
            qLIntervaloMaximoMecanizado: "mecanizado.intervaloMax",
            qLMetaMecanizado: "mecanizado.meta",
        };
    }

    static paramFields(tipoIndicadorField = '') {
        return <ParamFields tipoIndicadorField={tipoIndicadorField} />
    }

    static getEditFields(visita, isNew, TipoClass) {
        return <EditFields visita={visita} TipoClass={TipoClass} />
    }

    async renderReport(visita) {
        return Report(this, visita);
    }

    async renderReportSummary(visita, tipoName) {
        return ReportSummary(this, visita, tipoName);
    }

    static calcConformidade(apontamento, params) {
        const f = parseFloat;

        if (!apontamento.coletas || !params || apontamento.coletas.length === 0) {
            return 0;
        }

        let conformeCount = 0;
        const total = apontamento.coletas.length;

        for (const coleta of apontamento.coletas) {
            if (f(coleta.coleta) >= f(params.intervaloMin) && f(coleta.coleta) <= f(params.intervaloMax)) {
                coleta.conforme = "Sim";
                coleta.acima = 0
                coleta.abaixo = 0
                conformeCount++;
            } else {
                coleta.conforme = "Não";
                if (f(coleta.coleta) > f(params.intervaloMax)) {
                    coleta.acima = 1
                    coleta.abaixo = 0
                } else {
                    coleta.acima = 0
                    coleta.abaixo = 1
                }
            }
        }

        return ((100 * conformeCount) / total).toFixed(2);
    }

    static getConformidadeStatus(conformidade, meta) {
        return this.calcConformidadeStatus(conformidade, meta, 89.2, 100, 104.3);
    }

    static calcPontosAmostrados(apontamento, paramItems) {
        const result = [];

        for (const item of paramItems) {
            let count = 0;

            for (const coleta of apontamento.coletas) {
                if (this.calcPontoAmostradoColeta(item, coleta.coleta)) {
                    count++;
                }
            }

            result.push({
                ...item,
                count: count,
            });
        }

        return result;
    }

    static getResultStr(apontamento) {
        return "Pontos: " + apontamento.coletas?.length
    }

    static getTableRelApontamentos(paramsCliente, IndicadorClass) {
        return [
            { title: "Data", width: 'auto', getValue: (a) => a.dataRef.split("-").reverse().join('/') },
            { title: "Laudo", field: "laudoRef.sequencialIndex", width: 28 },
            { title: "Cod.", field: "laudoRef.fazenda.codFazenda", width: 'auto' },
            { title: "Fazenda", field: "laudoRef.fazenda.nomeFazenda" },

            { title: "Talhão", field: "talhao.nome" },

            { title: "Frota", field: "trator.numeroFrotaTrator", width: 'auto' },
            { title: "Frente", field: "frente", width: 'auto' },

            {
                title: "Conf.(%)", field: "conformidade", width: 38, getColor: a => {
                    return IndicadorClass.getColorStatus(IndicadorClass.getConformidadeStatus(a.conformidade, paramsCliente?.meta))
                }
            },
        ]
    }
}